import React from "react";
import useSidebarNavigation from "./hooks/useSidebarNavigation";
import useSidebarSession from "./hooks/useSidebarSession";
import { ENTITY_TYPES } from "./utils/sidebarStorage";
import LegalNavigation from "./components/LegalNavigation";
import MerchantNavigation from "./components/MerchantNavigation";
import SidebarBrand from "./components/SidebarBrand";
import SidebarUserMenu from "./components/SidebarUserMenu";
import "./../../Styles/sidebar.scss";

export default function RenovatedSidebar({
  isOpen = false,
  isHovered = false,
  isVisible = false,
  onClose,
  onOpen,
  onHoverChange,
  onNavigate,
  showBackdrop = false,
  className = "",
}) {
  const session = useSidebarSession();
  const { activeKey, goTo } = useSidebarNavigation(onNavigate);

  const isLegal = session.entityType === ENTITY_TYPES.legal;
  const isMerchant = session.entityType === ENTITY_TYPES.merchant;

  return (
    <>
      <aside
        className={`new-sidebar ${isVisible ? "is-open" : ""} ${
          isOpen ? "is-pinned" : ""
        } ${
          isHovered ? "is-hovered" : ""
        } ${isVisible ? "is-visible" : ""} ${className}`}
        aria-label="Main navigation"
        onMouseEnter={() => onHoverChange?.(true)}
        onMouseLeave={() => onHoverChange?.(false)}
      >
        <SidebarBrand
          isVisible={isVisible}
          onClose={onClose}
          onOpen={onOpen}
        />

        <nav className="new-sidebar__nav">
          {isLegal ? (
            <LegalNavigation
              activeKey={activeKey}
              bslStatus={session.bslStatus}
              features={session.features}
              onNavigate={goTo}
            />
          ) : null}

          {isMerchant ? (
            <MerchantNavigation
              activeKey={activeKey}
              entityRole={session.entityRole}
              onNavigate={goTo}
            />
          ) : null}
        </nav>

        <div className="new-sidebar__bottom">
          <SidebarUserMenu session={session} />
        </div>
      </aside>

      {isOpen && showBackdrop ? (
        <button
          type="button"
          className="new-sidebar-backdrop"
          aria-label="Close navigation"
          onClick={onClose}
        />
      ) : null}
    </>
  );
}

export { default as EntitySwitcher } from "./components/EntitySwitcher";
export { default as LegalNavigation } from "./components/LegalNavigation";
export { default as MerchantNavigation } from "./components/MerchantNavigation";
